export default __webpack_public_path__ + "static/media/logo-color-blackbg-square.f41ec6ef.svg";